import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';

import global_en from './i18n/en/global.json'
import global_es from './i18n/es/global.json'
import global_fi from './i18n/fi/global.json'
import global_sw from './i18n/sw/global.json'
import global_fr from './i18n/fr/global.json'

import { localeFromPathname, DEFAULT_LOCALE } from './i18n/locales';

// URL is the source of truth for language (G7). Each route — and each
// react-snap prerendered page — initialises i18next from its own path so the
// rendered markup is already in the correct locale before hydration.
const initialLocale = localeFromPathname(
  typeof window !== 'undefined' ? window.location.pathname : '/'
);

i18next.init({
  interpolation: { escapeValue: false },
  lng: initialLocale,
  fallbackLng: DEFAULT_LOCALE,
  resources: {
    ES: { global: global_es },
    FI: { global: global_fi },
    SW: { global: global_sw },
    FR: { global: global_fr },
    EN: { global: global_en }
  },
})

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders static markup into #root at build time; reuse it via
// hydrateRoot. In dev (empty #root) fall back to a fresh client render.
const container = document.getElementById('root');
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
